<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" ref="goodsOutTableRef" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="goodsTableRef" slot="wtFormTableList" :form.sync="form" @request-form-list="$refs.goodsOutTableRef.requestFormList()" @on-button-action="onButtonAction">
        <template slot="isPublish" slot-scope="data">
          <span class="publish-status" v-if="data.row.isPublish*1 === 1">已上架</span>
          <span class="normal-status" v-else>未上架</span>
        </template>
        <template slot="saleType" slot-scope="data">
          <span v-if="data.row.saleType*1 === 1">自提</span>
          <span v-if="data.row.saleType*1 === 2">售货柜</span>
        </template>
        <template slot="cover" slot-scope="data">
          <img class="table-img" v-if="data.row.cover && data.row.cover.length > 0" :src="imgUrl + data.row.cover.split(',')[0]">
        </template>
        <template slot="suspensionPath" slot-scope="data">
          <img class="table-img" :src="imgUrl + data.row.suspensionPath">
        </template>
        <template slot="wtFormTableListButtonsBefore" slot-scope="data">
          <wt-auth v-if="data.row.isHot*1 === 1" :hasAnyPremission="form.formCode + ':HOT'" class="search-form-btn">
            <el-button size="mini" @click="toHotClickAction(data.row)">取消热门</el-button>
          </wt-auth>
          <wt-auth v-if="data.row.isHot*1 !== 1" :hasAnyPremission="form.formCode + ':HOT'" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toHotClickAction(data.row)">设为热门</el-button>
          </wt-auth>
          <wt-auth v-if="data.row.isPublish*1 === 1" :hasAnyPremission="form.formCode + ':PUBLISH'" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toPublishClickAction(data.row)">取消上架</el-button>
          </wt-auth>
          <wt-auth v-if="data.row.isPublish*1 !== 1" :hasAnyPremission="form.formCode + ':PUBLISH'" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toPublishClickAction(data.row)">设置上架</el-button>
          </wt-auth>
        </template>
       </wt-form-table-list>
    </wt-form-table>
    <wt-detail-page :visible.sync="goodsRecordVisible" :component-name="'GoodsRecord'" component-type="edit" />
    <wt-detail-page :visible.sync="goodsPutInRecordVisible" :component-name="'GoodsPutInRecord'" component-type="edit" />
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_GOODS',
        formComponent: {
          view: { type: 'component', componentName: 'Goods-view', value: 'queryGoodsDetailData' },
          add: { type: 'component', componentName: 'Goods-edit', value: 'resetGoodsDetailData' },
          edit: { type: 'component', componentName: 'Goods-edit', value: 'queryGoodsDetailData' },
          list: { type: 'default', value: '/modules/goods/goodsList' },
          delete: { type: 'default', value: '/modules/goods/goodsDelete' }
        },
        formInputsData: [
          { name: '商品编号', key: 'goodsNo', value: '', type: 'text' },
          { name: '商品状态',
            key: 'isPublish',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '未上架', value: '0' },
              { label: '已上架', value: '1' }
            ] },
          { name: '商品积分', key: 'goodsRange', value: ['', ''], type: 'goodsRange' },
          { name: '商品积分小', key: 'goodsMinInventory', value: '', type: 'customAll' },
          { name: '商品积分大', key: 'goodsMaxInventory', value: '', type: 'customAll' },
          { name: '兑换方式',
            key: 'saleType',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '线下', value: '1' },
              { label: '线上', value: '2' }
            ] },
          { name: '商品名称', key: 'goodsName', value: '', type: 'text' }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', className: 'danger', hidden: false, permission: 'DELETE' },
          { name: '入库模板下载',
            key: 'DOWNLOAD',
            action: 'DOWNLOAD',
            hidden: false,
            permission: 'DOWNLOAD'
          },
          { name: '入库导入', key: 'IMPORT', action: 'IMPORT', hidden: false, type: 'IMPORT', url: window.wtConst.BASE_API + '/modules/goods/goodsPutListImport', permission: 'IMPORT' },
          { name: '入库记录', key: 'PUTINRECORD', action: 'PUTINRECORD', hidden: false, permission: 'PUTINRECORD' },
          { name: '商品模板下载',
            key: 'DOWNLOADGOODS',
            action: 'DOWNLOADGOODS',
            hidden: false,
            permission: 'DOWNLOAD'
          },
          { name: '商品导入', key: 'IMPORTGOODS', action: 'IMPORTGOODS', hidden: false, type: 'IMPORT', url: window.wtConst.BASE_API + '/modules/goods/goodsListImport', permission: 'IMPORT' },
          { name: '批量上架', key: 'PUBLISH', action: 'PUBLISH', hidden: false, permission: 'PUBLISH' },
          { name: '批量下架', key: 'CANCELPUBLISH', action: 'CANCELPUBLISH', hidden: false, permission: 'PUBLISH' }],
        formTableData: [
          { name: '商品编号', key: 'goodsNo', type: 'text' },
          { name: '商品图片', key: 'cover', type: 'custom' },
          { name: '商品标题', key: 'title', type: 'text' },
          { name: '兑换方式', key: 'saleType', type: 'custom' },
          { name: '积分', key: 'integral', type: 'text' },
          { name: '库存数', key: 'inventory', type: 'text' },
          { name: '商品类型', key: 'typeName', type: 'text' },
          { name: '状态', key: 'isPublish', type: 'custom' },
          { name: '创建时间', key: 'createTime', type: 'text', sortable: 'custom' }],
        formTableButtonsData: [{ name: '兑换记录', key: 'RECORD', action: 'RECORD', className: 'primary', hidden: false, permission: 'RECORD' },
          { name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonWidth: 430 }
      },
      goodsRecordVisible: false,
      goodsPutInRecordVisible: false
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'RECORD') {
          this.$store.dispatch('setGoodsId', data.row.id)
          this.goodsRecordVisible = true
        }
        if (data.item.action === 'PUTINRECORD') {
          this.goodsPutInRecordVisible = true
        }
        if (data.item.action === 'DOWNLOAD') {
          this.$wtUtil.downloadFileByUrl('https://ks3-external-huabei-1.bthcloud.com/shoukai-garbage/template/%E5%85%A5%E5%BA%93%E6%A8%A1%E6%9D%BF.xlsx')
        }
        if (data.item.action === 'DOWNLOADGOODS') {
          this.$wtUtil.downloadFileByUrl('https://ks3-external-huabei-1.bthcloud.com/shoukai-garbage/template/%E5%95%86%E5%93%81%E6%A8%A1%E6%9D%BF.xlsx')
        }
        if (data.item.action === 'PUBLISH') {
          this.toMultiPublish(1)
        }
        if (data.item.action === 'CANCELPUBLISH') {
          this.toMultiPublish(0)
        }
      }
    },
    toMultiPublish(state) {
      if (this.form.formSelectedList && this.form.formSelectedList.length > 0) {
        const dataIdList = []
        for (const item of this.form.formSelectedList) {
          if (state ? item.isPublish : !item.isPublish) {
            this.$alert('选择的数据中包含' + (state ? '已上' : '未上') + '架数据，请重新选择', '提示', {
              type: 'error',
              confirmButtonText: '确定'
            }).then(() => {}).catch(() => {})
            return
          }
          dataIdList.push(item.id)
        }

        this.$wtUtil.deleteConfirm(this, state === 1 ? '确认上架？' : '确认取消上架？').then(() => {
          this.$api.mall.goods.goodsIsPublishMultipart({
            ids: dataIdList,
            state: state
          }).then(res => {
            if (res.code === '0') {
              this.$message({ message: '操作成功', type: 'success' })
              this.$refs.goodsTableRef.requestList()
            }
          })
        })
      } else {
        this.$alert('请选中至少一列数据', '提示', {
          type: 'error',
          confirmButtonText: '确定'
        }).then(() => {}).catch(() => {})
      }
    },
    toPublishClickAction(row) {
      this.$wtUtil.deleteConfirm(this, row.isPublish === 1 ? '确认取消上架？' : '确认上架？').then(() => {
        this.$api.mall.goods.goodsIsPublish({
          id: row.id,
          state: row.isPublish === 1 ? 0 : 1
        }).then(res => {
          if (res.code === '0') {
            this.$message({ message: '操作成功', type: 'success' })
            this.$refs.goodsTableRef.requestList()
          }
        })
      })
    },
    toHotClickAction(row) {
      this.$wtUtil.deleteConfirm(this, row.isHot === 1 ? '确认取消热门？' : '确认设置热门？').then(() => {
        this.$api.mall.goods.goodsIsHot({
          id: row.id,
          state: row.isHot === 1 ? 0 : 1
        }).then(res => {
          if (res.code === '0') {
            this.$message({ message: '操作成功', type: 'success' })
            this.$refs.goodsTableRef.requestList()
          }
        })
      })
    }
  }
}
</script>
